import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { moduleStructure } from '../../core/config/moduleStructure';
import { useGlobalTheme } from '../hooks/useGlobalTheme';
import { getModuleManagementTitle } from '../utils/moduleNavI18n';

const ModuleBadge = ({ className = '' }) => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { isDashboardLightMode } = useGlobalTheme();
  const isRTL = i18n.language && i18n.language.startsWith('ar');

  const currentModule = moduleStructure.find(module =>
    module.subsections.some(subsection =>
      location.pathname === subsection.href ||
      location.pathname.startsWith(subsection.href + '/')
    )
  );

  if (!currentModule) return null;

  const title = getModuleManagementTitle(currentModule, t);

  return (
    <span
      className={`hidden lg:inline text-lg font-medium ${
        isDashboardLightMode ? 'text-slate-900' : 'text-white/90'
      } ${className} ${isRTL ? 'text-right' : ''}`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {title}
    </span>
  );
};

export default ModuleBadge;
